import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class TicketStatusPickerController implements angular.IComponentController {
    static $inject = [];
}

export const wtTicketStatusPicker: ComponentDefinition = {
    componentId: 'wtTicketStatusPicker',
    controller: TicketStatusPickerController,
    template: require('./ticketStatusPicker.component.html'),
    controllerAs: 'vm',
    bindings: {
        ticketStatuses: '<',
        name: '@',
        model: '='
    }
};
